import React from "react";
import PropTypes from "prop-types";
import { AsyncCombobox } from "@sainsburys-tech/fable";
import "./StoresDropdown.css";

const StoresDropdown = props => {
  const stores = props.stores
    ? props.stores.map(store => ({
        value: store.storeId,
        label: /^[a-zA-Z]+$/.test(store.storeId)
          ? `${store.name}`
          : `${store.name} (${store.storeId})`
      }))
    : [];

  const selectedStore =
    stores !== null
      ? stores.find(store => store.value === props.storeId)
      : null;

  const getOptions = async value => {
    if (!value) return stores;
    return stores.filter(store =>
      store.label.toLowerCase().includes(value.toLowerCase())
    );
  };

  return (
    <div className="stores-dropdown">
      <AsyncCombobox
        label={props.label}
        placeholder="Please select a store"
        isClearable
        name="Store"
        onSelection={option => props.handleStoreChanged(option)}
        options={getOptions}
        emptyListMessage="No stores found"
        status={props.error ? { type: "error", message: props.error } : undefined}
      />
    </div>
  );
};

StoresDropdown.defaultProps = {
  label: "Store"
};

StoresDropdown.propTypes = {
  stores: PropTypes.arrayOf(
    PropTypes.shape({
      storeId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ).isRequired,
  handleStoreChanged: PropTypes.func,
  selectedStore: PropTypes.object,
  error: PropTypes.string,
  storeId: PropTypes.string,
  label: PropTypes.string
};

export default StoresDropdown;
